import SecureRequest from "../utils/securerequest";

export function* getComputerPerformance() {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return yield Request.get("/features/performance");
}
